export default {
  // Robot status
  statusTitle: 'Robot Status',
  statusNoData: 'No data',
  statusSn: 'SN: ',
  statusSelfCheck: 'Self-check: ',
  statusInTask: 'On task: ',
  statusBattery: 'Battery',
  statusCharging: 'Charging',
  statusNotCharging: 'Not charging',
  statusVoltage: 'Voltage',
  statusBatteryTemp: 'Battery temp',
  statusCycle: 'Cycles',
  statusTelemetry: 'Telemetry',
  statusHostTemp: 'Host temp',
  statusForwardSpeed: 'Forward speed',
  statusChassis: 'Chassis',
  statusRuntime: 'Uptime',
  statusMotion: 'Motion',
  statusStrafeSpeed: 'Strafe speed',
  statusAngularSpeed: 'Angular speed',
  statusControllerStopped: 'Controller stopped',
  statusNav: 'Navigation',
  statusNavPhase: 'Nav phase',
  statusTargetStation: 'Target station',
  statusPose: 'Pose',
  statusYaw: 'Heading',
  statusMove: 'Move',
  statusExpand: 'Expand',
  statusCollapse: 'Collapse',
  statusForward: 'Forward',
  statusBackward: 'Backward',
  statusLeft: 'Left',
  statusRight: 'Right',
  statusEstop: 'E-stop',
  statusMoving: 'Moving {dir}…',
  statusMoveDisabledHint: 'Direction pad disabled. E-stop is available.',
  statusMoveHint: 'Hold a direction to move, release to stop',
  statusMoveFailed: 'Move command failed',
  statusEstopSent: 'E-stop sent',
  statusEstopFailed: 'E-stop failed',
  statusBack: 'Back',
  timesUnit: 'times',

  // Camera
  cameraTitle: 'Camera Live',
  cameraLeftWrist: 'Left Wrist',
  cameraHead: 'Head',
  cameraRightWrist: 'Right Wrist',
  cameraSignalLost: 'Signal lost',
  cameraStreamUnconfigured: 'Stream not configured',
  cameraStreamFailed: 'Stream failed',
  cameraFullscreen: 'Fullscreen',
  cameraClose: 'Close',
  cameraLoading: 'Loading...',

  // Map
  mapTitle: 'Map',
  mapView2d: '2D Grid',
  mapLegendCurrent: 'Current',
  mapLegendPath: 'Path',
  mapLegendStation: 'Station',
  mapLegendTarget: 'Target',
  mapLoadingTitle: 'Loading map',
  mapLoadingHint: 'Fetching occupancy grid…',
  map25dOccupancy: 'Occupancy',
  map25dTrail: 'Trail',
  map25dLabels: 'Labels',
  map25dLoading: 'Loading 2.5D map…',
  map25dUnsupported: 'No 2.5D map for this device',
  map25dUnsupportedHint: 'SN: {sn} · Add a robot map under map25d/robots',
  map25dLabelCartonRack: 'Double-layer carton rack · 195 × 90 cm',
  map25dLabelBasketRack: 'Full basket rack · 350 × 110 cm',
  map25dLabelMaterialShelf: 'Material shelf',

  // Work order pool
  workOrderPool: 'Work Orders',
  orderUnit: '{n} orders',
  statusNew: 'New',
  statusPending: 'Queued',
  statusInProgress: 'In progress',
  statusCompleted: 'Completed',
  statusUnknown: 'Unknown',
  traysUnit: 'trays',
  traysProgress: '{delivered}/{total} trays',

  // Work order detail
  workOrderDetail: 'Work Order Detail',
  workOrderRoute: 'Route',
  workOrderTrays: 'Trays',
  workOrderEvents: 'Execution',
  workOrderNoEvents: 'No execution records',
  workOrderNotFound: 'Work order not found',

  // Task agent
  agentTitle: 'Task Agent',
  agentEmpty: 'Waiting for task events...',
  agentLive: 'Live',
  agentConnecting: 'Connecting',
  agentConnected: 'Connected',
  agentDisconnected: 'Disconnected',
  agentLatest: 'Latest',
  agentStatusUpdate: 'Status update',
  agentNextStep: 'Next: ',
  itemsUnit: 'pcs',
  decisionLabel: 'Decision',

  // Layout
  splitAriaLabel: 'Resize work order pool and task agent',
}
